export function formatError(error: unknown): string {
  return (
    (error as { message?: string })?.message ??
    (typeof error === 'object' ? JSON.stringify(error) : String(error))
  )
}
